import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ProjectsPage = loadAsyncComponent(() => import('./Container'), 'page');
